import React from 'react';
import styled from 'styled-components';
import TheInsideLogo from './svgs/TheInsideLogo';

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  background: rgba(255, 255, 255, 0.4);
  position: absolute;
  left: 0;
`;

const LoadingContainer = styled.div`
  min-height: 600px;
`;

const LoadingScreenWrapper = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 1;
  top: -200px;
  img {
    opacity: 1;
    animation: 1.5s infinite beatHeart;
    width: 200px;
    height: auto;
  }
  @keyframes beatHeart {
    0% {
      transform: scale(1);
    }
    25% {
      transform: scale(1.1);
    }
    40% {
      transform: scale(1);
    }
    60% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }
`;

function LoadingScreen({ styles }) {
  return (
    <LoadingContainer>
      <Wrapper className="loading-wrapper" style={styles}>
        <LoadingScreenWrapper>
          <TheInsideLogo />
        </LoadingScreenWrapper>
      </Wrapper>
    </LoadingContainer>
  );
}

export default LoadingScreen;
